/* 
Importing the components and dependencies
*/
import SummerNote from '../../SummerNoteEditor/SummerNote';
import * as service from './StatusReports.service.js';
import uuidv4 from 'uuid/v4';
import { GetUserDetails } from '../../../config/app.config';
import moment from 'moment';
import ReportStatusTasks from '../ReportStatusTasks/ReportStatusTasks';
import NotificationContactInfo from '../NotificationContactInfo/NotificationContactInfo';
import * as notificationService from '../../../Service/Notification.service';
import { ReportTypeConstants } from '../../../Constants/ReportTypesConstants';
import { Capitalize } from '../../../Utility/Capitalize';
/* 
Logics for the StatusReport
*/
export default {
    components: {
        SummerNote,
        ReportStatusTasks,
        NotificationContactInfo,
    },
    data() {
        return {
            loading: false,
            snackbar: false,
            snackbarColor: '',
            snackbarText: '',
            activityShow: false,
            role: '',
            fullName: '',
            reportName: '',
            managerResponse: [],
            leaderResponse: [],
            statusActivity: [],
            displaystatusActivity: [],
            reportStatus: '',
            documentId: '',
            reportType: '',
            mgrRespCreateBy: '',
            mgrRespCreateOn: '',
            ldrRespCreateBy: '',
            ldrRespCreateOn: '',
            htmltoPrint: '',
            area: '',
            team: '',
            office: '',
            activeTab: 0,
            isNotificationPopup: false,
            addCommentTabName: 'Add Comment',
            showSubmitConfirmation: false,
            firstName: '',
            lastName: '',
        };
    },
    created() {},
    mounted() {
        /* 
    generate Editors with data from firestore
    */

        let userDetails = GetUserDetails();
        if (userDetails) {
            this.fullName = userDetails.FirstName + ' ' + userDetails.LastName;
            this.firstName = userDetails.FirstName;
            this.lastName = userDetails.LastName;
            this.role = userDetails.Role;
            this.office = userDetails.Office;
        }

        // Runs when changing Date filter
        this.$router.app.$on('UpdateStatusReport', (data) => {
            this.documentId =
                data.FilterPeriod.ReportPrefix +
                '-' +
                data.Area +
                '-' +
                data.Team +
                '-' +
                data.FilterPeriod.ReportSuffix;
            this.area = data.Area;
            this.team = data.Team;
            this.reportType = data.FilterPeriod.ReportType;
            this.reportName = data.FilterPeriod.ReportType + ' Report';

            this.getResponseData(this.documentId);
        });

        this.$router.app.$on(
            'saveContentTrigger',
            (status, submittedBy, action) => {
                if (submittedBy == 'Manager') {
                    this.saveResponseByManager(action);
                } else if (submittedBy == 'Leader') {
                    this.saveResponseByLeader(action);
                }
                if (status != '') {
                    this.editorEnableDisable();
                }
            },
        );

        this.$router.app.$on('snackbarTrigger', (data) => {
            this.snackbarColor = data.color;
            this.snackbarText = data.text;
            this.snackbar = true;
        });

        //Emitting from NotificationContentInfo
        //For closing the contact info Poppup
        this.$router.app.$on(
            'CloseContentInfoPopup',
            this.closeContentInfoPopup,
        );

        let context = this;
    },
    methods: {
        openConfirmationWindowSubmitReport() {
            this.showSubmitConfirmation = true;
        },
        toggleAddCommentSummerNote(tabName = '') {
            var summerNoteElement = document.getElementById(
                this.addCommentTabName,
            );
            if (summerNoteElement != null) {
                switch (this.role) {
                    case 'Manager':
                        if (
                            this.reportStatus != 'Working' ||
                            tabName == 'Response'
                        ) {
                            $(summerNoteElement).summernote('disable');
                        } else {
                            $(summerNoteElement).summernote('enable');
                        }
                        break;

                    case 'Leader':
                        if (this.reportStatus == 'Accepted') {
                            $(summerNoteElement).summernote('disable');
                        } else {
                            $(summerNoteElement).summernote('enable');
                        }
                        break;

                    case 'Admin':
                        break;
                }
            }
        },
        getResponseData(docId) {
            let context = this;
            context.loading = true;
            service
                .getResponseData(docId)
                .then(function(querySnapshot) {
                    if (querySnapshot.exists) {
                        context.managerResponse = querySnapshot.data().responseData.ManagerResponses;
                        if (context.managerResponse.length > 0) {
                            context.mgrRespCreateOn = querySnapshot.data().responseData.ManagerResponses[0].createdOn;
                            context.mgrRespCreateBy = querySnapshot.data().responseData.ManagerResponses[0].createdBy;
                        }

                        context.leaderResponse = querySnapshot.data().responseData.LeaderResponse;
                        context.ldrRespCreateOn = querySnapshot.data().responseData.LeaderResponse[0].createdOn;
                        context.ldrRespCreateBy = querySnapshot.data().responseData.LeaderResponse[0].createdBy;
                        context.statusActivity = querySnapshot.data()
                            .responseData.StatusActivity
                            ? querySnapshot.data().responseData.StatusActivity
                            : [];
                        let arryActivity = [];
                        for (var key in context.statusActivity) {
                            const formattedcreatedOn = moment(
                                context.statusActivity[key].createdOn,
                            ).fromNow();

                            const obj = {
                                createdBy:
                                    context.statusActivity[key].createdBy,
                                createdOn: formattedcreatedOn,
                                id: context.statusActivity[key].id,
                                reportStatus:
                                    context.statusActivity[key].reportStatus,
                            };
                            arryActivity.push(obj);
                        }
                        context.displaystatusActivity = arryActivity;
                        context.reportStatus = querySnapshot.data()
                            .responseData.ReportStatus
                            ? querySnapshot.data().responseData.ReportStatus
                            : 'Working';
                    } else {
                        let tabArray = [];
                        service
                            .generateTabs(context.reportType)
                            .then(function(querySnapshot) {
                                querySnapshot.forEach(function(doc, index) {
                                    const data = {
                                        tabName: doc.data().TabName,
                                        content: '',
                                        ordinance: doc.data().Ordinance,
                                        createdBy: context.fullName,
                                        createdOn: new Date().toString(),
                                    };
                                    tabArray.push(data);
                                });
                                tabArray.sort((a, b) =>
                                    a.ordinance > b.ordinance ? 1 : -1,
                                );
                                context.managerResponse = tabArray;
                                context.leaderResponse = [
                                    {
                                        tabName: 'Response',
                                        content: '',
                                        createdBy: context.fullName,
                                        createdOn: new Date().toString(),
                                    },
                                ];
                                context.statusActivity = [];
                                context.reportStatus = 'Working';

                                const initResponseData = {
                                    ReportStatus: context.reportStatus,
                                    ManagerResponses: context.managerResponse,
                                    LeaderResponse: context.leaderResponse,
                                    StatusActivity: context.statusActivity,
                                };
                                service.saveResponseData(
                                    initResponseData,
                                    docId,
                                );
                            })
                            .then(function(result) {
                                context.editorEnableDisable();
                            });
                    }
                })
                .then(function(result) {
                    context.toggleAddCommentSummerNote();
                    context.editorEnableDisable();
                });
        },
        clearSummerNote(elementId) {
            var summerNoteComment = document.getElementById(elementId);

            var summernoteContent = $(summerNoteComment).summernote(
                'code',
                '',
            );
        },

        editorEnableDisable() {
            /* 
          set readability of Editors based on role
          */
            // if (this.role == "Manager") {
            //   $("#managerResponse .summernote").each(function(item) {
            //     $(this).summernote("enable");
            //   });
            //   $("#leaderResponse .summernote").summernote("disable");
            //   if (this.reportStatus != "Working") {
            //     $("#managerResponse .summernote").each(function(item) {
            //       $(this).summernote("disable");
            //     });
            //   }
            // } else if (this.role == "Leader") {
            //   $("#leaderResponse .summernote").summernote("enable");
            //   $("#managerResponse .summernote").each(function(item) {
            //     $(this).summernote("disable");
            //   });
            //   if (this.reportStatus == "Accepted") {
            //     $("#leaderResponse .summernote").summernote("disable");
            //   }
            // } else if (this.role == "Admin") {
            //   $("#managerResponse .summernote").each(function(item) {
            //     $(this).summernote("enable");
            //   });
            //   $("#leaderResponse .summernote").summernote("enable");
            //   if (this.reportStatus == "Accepted") {
            //     $("#managerResponse .summernote").each(function(item) {
            //       $(this).summernote("disable");
            //     });
            //     $("#leaderResponse .summernote").summernote("disable");
            //   }
            // } else {
            //   $(".summernote").each(function(item) {
            //     $(this).summernote("disable");
            //   });
            // }
            this.loading = false;
        },
        generateNotificationMessage(fullName, reportName) {
            return (
                fullName +
                ' has added a new message to ' +
                reportName +
                ' report in iLead Application'
            );
        },
        async saveData(status, submittedBy, action) {
            this.showSubmitConfirmation = false;
            this.$router.app.$emit('standByTrigger', true);

            if (submittedBy == 'Manager') {
                var contactList = await notificationService.getContactsToNotify(
                    this.area,
                    this.team,
                    this.office,
                    ReportTypeConstants.SalesReport,
                );

                var fullName =
                    Capitalize(this.firstName) +
                    ' ' +
                    Capitalize(this.lastName);

                var notificationMessage = this.generateNotificationMessage(
                    fullName,
                    ReportTypeConstants.SalesReport,
                );
                if (contactList.length > 0) {
                    contactList.forEach((contact) => {
                        notificationService.sendNotification(
                            notificationMessage,
                            contact.Number,
                        );
                    });
                }
            }

            // If it is not saved as  draft
            if (status != '') {
                this.toggleAddCommentSummerNote();
                let context = this;
                const datActivity = {
                    id: uuidv4(),
                    reportStatus: status,
                    createdBy: context.fullName,
                    createdOn: new Date().toString(),
                };
                const datToDisplay = {
                    id: uuidv4(),
                    reportStatus: status,
                    createdBy: context.fullName,
                    createdOn: moment(new Date().toString()).fromNow(),
                };
                context.statusActivity.push(datActivity);
                context.displaystatusActivity.push(datToDisplay);
                context.reportStatus =
                    status == 'Reopened' ? 'Working' : status;
            }
            let TotalImageCount = service.GetTotalImageCount();
            if (TotalImageCount == 0) {
                switch (submittedBy) {
                    case 'Manager':
                        this.saveResponseByManager(action);
                        break;

                    case 'Leader':
                        this.saveResponseByLeader(action);
                        break;
                }

                if (status != '') {
                    this.editorEnableDisable();
                }
            } else {
                this.$router.app.$emit(
                    'saveImageTrigger',
                    status,
                    submittedBy,
                    action,
                );
            }
        },

        /* 
    save responseData to firestore
    */
        saveResponse(responseData, docId, action) {
            let context = this;
            service.saveResponseData(responseData, docId).then(
                (response) => {
                    context.$router.app.$emit('standByTrigger', false);
                    context.snackbarColor = 'success';
                    context.snackbarText = action + ' Successfully';
                    context.snackbar = true;
                    if (context.activeTab < 3) {
                        context.$router.app.$emit(
                            'updateContentSummerNote',
                            context.managerResponse[context.activeTab].tabName,
                            responseData.ManagerResponses[context.activeTab]
                                .content,
                        );
                    } else {
                        context.$router.app.$emit(
                            'updateContentSummerNote',
                            responseData.LeaderResponse[0].tabName,
                            responseData.LeaderResponse[0].content,
                        );
                    }

                    context.clearSummerNote(context.addCommentTabName);
                },
                (error) => {},
            );
        },

        saveResponseByManager(action) {
            // this.saveImage();

            let context = this;
            var responseData = {
                ReportStatus: this.reportStatus,
                ManagerResponses: this.getManagerResponseData(),
                StatusActivity: context.statusActivity,
            };

            this.saveResponse(responseData, context.documentId, action);
        },

        saveResponseByLeader(action) {
            // this.saveImage();
            let context = this;
            var responseData = {
                ReportStatus: this.reportStatus,
                LeaderResponse: this.getLeaderResponseData(),
                ManagerResponses: this.getManagerResponseData(),
                StatusActivity: context.statusActivity,
            };
            this.saveResponse(responseData, context.documentId, action);
        },

        /* 
    read editor dataobjects
    */
        getManagerResponseData() {
            let context = this;
            let arrayManagerResponses = [];
            var activeTabName = '';
            if (this.activeTab <= this.managerResponse.length - 1) {
                activeTabName = this.managerResponse[this.activeTab].tabName;
            }

            $('#managerResponse .summernote').each(function(item) {
                const data = {
                    tabName: $(this).attr('id'),
                    content: $(this).summernote('code'),
                    createdBy: context.mgrRespCreateBy,
                    createdOn: context.mgrRespCreateOn,
                    updatedBy: context.fullName,
                    updatedOn: new Date().toString(),
                };

                if ($(this).attr('id') == activeTabName) {
                    var summerNoteComment = document.getElementById(
                        context.addCommentTabName,
                    );

                    var summernoteContent = $(summerNoteComment).summernote(
                        'code',
                    );
                    if (summernoteContent != '') {
                        data.content =
                            context.generateMessage(
                                summernoteContent,
                                context.fullName,
                            ) +
                            '<br/>' +
                            data.content;
                    }
                }

                arrayManagerResponses.push(data);
            });

            return arrayManagerResponses;
        },
        generateMessage(summernoteContent, fullName) {
            var content =
                '<i>' +
                fullName +
                '</i> ' +
                ' <i>' +
                new Date().toLocaleTimeString() +
                '</i> <br>' +
                summernoteContent +
                '<br/>';

            return content;
        },
        getLeaderResponseData() {
            let context = this;
            let arrayleaderResponse = [];
            $('#leaderResponse .summernote').each(function(item) {
                const data = {
                    tabName: $(this).attr('id'),
                    content: $(this).summernote('code'),
                    createdBy: context.ldrRespCreateBy,
                    createdOn: context.ldrRespCreateOn,
                    updatedBy: context.fullName,
                    updatedOn: new Date().toString(),
                };

                if (context.activeTab > 2) {
                    var summerNoteComment = document.getElementById(
                        context.addCommentTabName,
                    );

                    var summernoteContent = $(summerNoteComment).summernote(
                        'code',
                    );
                    if (summernoteContent != '') {
                        data.content =
                            context.generateMessage(
                                summernoteContent,
                                context.fullName,
                            ) +
                            '<br/>' +
                            data.content;
                    }
                }

                arrayleaderResponse.push(data);
            });
            return arrayleaderResponse;
        },
        printReports() {
            let reportSubmittedBy = '';
            let reportSubmittedOn = '';
            for (var key in this.statusActivity.sort((a, b) =>
                a.createdOn > b.createdOn ? 1 : -1,
            )) {
                if (this.statusActivity[key].reportStatus == 'Submitted') {
                    reportSubmittedBy = this.statusActivity[key].createdBy;
                    reportSubmittedOn = moment(
                        this.statusActivity[key].createdOn,
                    ).format('ll');
                    break;
                }
            }
            let context = this;
            context.htmltoPrint = '';
            context.htmltoPrint =
                "<div><img src='logo-lbc.png'></div><br/><br/><div style='margin-bottom: 27px;'><h3>" +
                context.reportType +
                " Report<span style='float:right;font-size: medium;text-align: right;'><div><v-btn flat style='margin-right: 25px;'>Area: " +
                context.area +
                '</v-btn><v-btn flat>Team: ' +
                context.team +
                '</v-btn></div><div><v-btn flat>' +
                reportSubmittedBy +
                '</v-btn></div><div><v-btn flat>' +
                reportSubmittedOn +
                "</v-btn></div></span></h3></div><hr/><br/><v-layout><v-flex><div align='center'><h4>Manager Responses</h4></div>";
            $('#managerResponse .summernote').each(function(item) {
                if ($(this).summernote('code')) {
                    context.htmltoPrint +=
                        "<div style='margin-bottom: 25px;'><h2 style='font-size: medium;margin-bottom:10px;'>" +
                        $(this).attr('id') +
                        ':</h2><div>' +
                        $(this).summernote('code') +
                        '</div></div>';
                }
            });
            context.htmltoPrint +=
                "</v-flex></v-layout><br/><hr/><br/><v-layout><v-flex><div align='center'><h4>Leader Response</h4></div>";
            $('#leaderResponse .summernote').each(function(item) {
                if ($(this).summernote('code')) {
                    context.htmltoPrint +=
                        "<div><h2 style='font-size: medium;margin-bottom:10px;'>" +
                        $(this).attr('id') +
                        ':</h2><div>' +
                        $(this).summernote('code') +
                        '</div></div>';
                }
            });
            context.htmltoPrint += '</v-flex></v-layout></v-card>';

            setTimeout(function() {
                context.$htmlToPaper('printReport');
            }, 1000);
        },
        closeContentInfoPopup() {
            this.isNotificationPopup = false;
        },
    },
    beforeDestroy() {
        this.$router.app.$off('UpdateStatusReport');
        this.$router.app.$off('saveContentTrigger');
        this.$router.app.$off('snackbarTrigger');
        this.$router.app.$off('CloseContentInfoPopup');
    },
};
